import { handleResponse } from '../Helpers/handle-response';
import * as tmsApiHelper from '../Helpers/tmsApiHelper';
import * as hiveApiHelper from '../Helpers/hiveApiHelper';
import * as shopfloorApiHelper from '../Helpers/shopfloorApiHelper';
import { MysoftApplicationID } from '../AppData/constants'


export const dataService = {
    getHive,
    getAGVs,
    getActiveTransportOrdersWithDetails,
    getCompletedTransportOrdersWithDetails,
    getSendableStates,
    sendStatus,
    cancelTransportOrder,
    getTransportOrdersHistory,
    getBlockedPackagingMachines,
    blockMachine,
    unBlockMachine,
    getRestartableServices,
    restartService,
    authenticate
};

function getHive() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };
    console.log("get hive called");
    return fetch(hiveApiHelper.ComposeUri(hiveApiHelper.HIVE_API_BASE_URL, hiveApiHelper.API_ACTION_HIVE_STATUS), requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getAGVs() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json'
        }
    };

    return fetch(hiveApiHelper.ComposeUri(hiveApiHelper.HIVE_API_BASE_URL, hiveApiHelper.API_ACTION_AGV_STATUS), requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getActiveTransportOrdersWithDetails() {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    return fetch(tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_ACTIVE_ORDERS), requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getCompletedTransportOrdersWithDetails() {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    return fetch(tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_COMPLETED_ORDERS), requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getTransportOrdersHistory(from, untill) {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_ORDERS_HISTORY);
    url += `?from=${String(from.toLocaleDateString("en-US"))}`;
    url += `&to=${String(untill.toLocaleDateString("en-US"))}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSendableStates(transportOrderId) {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_SENDABLE_STATES);
    url += `?transportOrderId=${transportOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function sendStatus(transportOrderId, transportOrderStatus, userName) {
    const requestOptions = {
        method: 'POST', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_SEND_STATUS);
    url += `?transportOrderID=${transportOrderId}`;
    url += `&transportOrderStatus=${transportOrderStatus}`;
    url += `&userName=${userName}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function cancelTransportOrder(transportOrderId, userName) {
    const requestOptions = {
        method: 'POST', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_CANCEL_TRANSPORTORDER);
    url += `?transportOrderID=${transportOrderId}`;
    url += `&userName=${userName}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getBlockedPackagingMachines() {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_BLOCKED_MACHINES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function blockMachine(machineCode, userName) {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_BLOCK_LINE);
    url += `?machineCode=${machineCode}`;
    url += `&userName=${userName}`;


    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function unBlockMachine(machineCode, userName) {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': tmsApiHelper.ComposeAuthToken()
        }
    };

    let url = tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_UNBLOCK_LINE);
    url += `?machineCode=${machineCode}`;
    url += `&userName=${userName}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getRestartableServices() {
    const requestOptions = {
        method: 'GET', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': shopfloorApiHelper.ComposeAuthToken()
        }
    };

    let url = shopfloorApiHelper.ComposeUri(shopfloorApiHelper.SHOPFLOOR_API_BASE_URL, shopfloorApiHelper.API_ACTION_GET_RESTARTABLE_SERVICES);
    url += `?applicationID=${MysoftApplicationID}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.log(error);
            return null;
        });
}

function restartService(serviceID, userID){
    //RestartService(int serviceID, int userID
    const requestOptions = {
        method: 'POST', credentials: 'include', headers: {
            'Content-Type': 'application/json', 'Authorization': shopfloorApiHelper.ComposeAuthToken()
        }
    };

    let url = shopfloorApiHelper.ComposeUri(shopfloorApiHelper.SHOPFLOOR_API_BASE_URL, shopfloorApiHelper.API_ACTION_RESTART_SERVICE);
    url += `?serviceID=${serviceID}&userID=${userID}`;
    console.log(url);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.log(error);
            return null;
        });
}

function authenticate(username, password) {
    const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': tmsApiHelper.ComposeAuthToken()
        },
        body: JSON.stringify({
            username: username,
            password: password,
        })
    };

    return fetch(tmsApiHelper.ComposeUri(tmsApiHelper.TMS_API_BASE_URL, tmsApiHelper.API_ACTION_LOGIN), requestOptions)
        .then(handleResponse);
}